module.exports = __webpack_public_path__ + "static/media/medal.a5e979b5.png";